import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxModule, DxCheckBoxModule, DxTemplateModule } from 'devextreme-angular';
import { FusService } from '../../../services/formulacion/fus.service';
import { ReversionService } from '../../../services/formulacion/reversion.service';
import { switchMap } from 'rxjs/operators';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';
import { GeneralService } from 'src/app/services/service.index';
declare var jQuery: any;
declare var toastr;

@Component({
  selector: 'app-ppto-fus',
  templateUrl: './ppto-fus.component.html',
  styleUrls: [],
  providers: [FusService, ReversionService]
})
export class PptoFusComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  dataSeg: any = [];
  fusSeg: string = '';
  popupVisibleSeg: boolean = false;
  tipo_agregacion_id: number = 1;
  esNuevaObs: boolean = false;
  dataResourceObs: any[];
  nroFus: string;
  fuses: any[];
  fusesAprobar: any[] = [];
  fus: any;
  fusReversion: any;
  estadosFilter: any = [];
  estado: number = 14;
  popupVisibleA: boolean = false;
  popupVisibleO: boolean = false;
  popupVisibleR: boolean = false;
  model: any;
  estados: any[] = [{ id: 3, descripcion: 'Observado' }, { id: 4, descripcion: 'Aprobado' }];
  clicked: boolean = false;
  baseUrl = environment.apiEndpoint;
  baseUrld = environment.apiEndpoint.substring(0, environment.apiEndpoint.length - 4);
  file: File = null;
  maxFileSize = 2097152;
  typeFiles = ['application/pdf', 'image/jpeg', 'image/png'];
  //typeFiles = ['application/pdf', 'image/jpeg', 'image/png', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
  fechaRM = new Date();
  jusReversion = false;
  hasError: any;

  constructor(private route: ActivatedRoute, private _fs: FusService, private _rs: ReversionService, private _gs: GeneralService) {
    this.getEstadosByUsuario();
    this.resetErrors();
  }

  ngOnInit() {
  }

  getEstadosByUsuario() {
    this._fs.getFusEstadosByUsuario().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.estadosFilter = result.data;
          this.getListFus(this.estado, this.tipo_agregacion_id);
        }
        else { this.estadosFilter = []; }
      },
      (error) => { console.log('Error', error); });
  }

  getListFus(id: number, tipo_agregacion_id: number) {
    this._fs.getListFusByEstadoId(id, this.tipo_agregacion_id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) { this.fuses = result.data; }
        else { this.fuses = []; }
      },
      (error) => { console.log('Error', error); });
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    },
      {
        location: 'before',
        widget: 'dxButton',
        options: {
          icon: 'refresh',
          text: 'Actualizar',
          onClick: this.refreshDataGrid2.bind(this)
        }
      });
  }

  refreshDataGrid(e) {
    this.getListFus(e.value, this.tipo_agregacion_id);
    this.dataGrid.instance.refresh();
    this.estado = e.value;
  }

  refreshDataGrid2(e) {
    this.getListFus(this.estado, this.tipo_agregacion_id);
    this.dataGrid.instance.refresh();
  }

  aprobarFUS() {
    this.clicked = true;
    this.model.fechaC31 = this.convertDate(this.fechaRM);
    this.model.fuses = this.fusesAprobar;
    if (this.validSave()) {
      this._fs.postFusApruebaPtto(this.model, this.file).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.getListFus(this.estado, this.tipo_agregacion_id);
            this.dataGrid.instance.refresh();
            toastr.success('Datos guardados correctamente.');
            this.clicked = false;
          }
          if (result.status == 201) {
            toastr.warning('Le falta un total de: ' + result.data);
            this.clicked = false;
          }
          this.popupVisibleA = false;
        });
    }
  }

  observarFUS() {
    if (this.validObs()) {
      this.clicked = true;
      this._fs.putFusObservaPtto(this.model).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.getListFus(this.estado, this.tipo_agregacion_id);
            this.dataGrid.instance.refresh();
            toastr.success('Datos guardados correctamente.');
            this.clicked = false;
          }
          this.popupVisibleO = false;
        });
    }
  }

  validSave() {
    let res = true;
    if (this.model.observacion == '') {
      this.hasError.observacion = true; res = false;
    }
    if (!UtilHelper.validator(this.model.nroC31, 'text')) {
      this.hasError.nroC31 = true; res = false;
    }
    if (!UtilHelper.validator(this.model.montoC31, 'text')) {
      this.hasError.montoC31 = true; res = false;
    }
    if (!UtilHelper.validator(this.model.fechaC31, 'ddmmyyyy')) {
      this.hasError.fechaC31 = true; res = false;
    }
    if (this.file != null) {
      if (this.file.size > this.maxFileSize) {
        toastr.warning('El tamaño del archivo no debe exceder los 2MB.');
        this.hasError.file = true; res = false;
      }
      if (this.typeFiles.indexOf(this.file.type) == -1) {
        toastr.warning('Formato de archivo no válido, los permitidos son PDF, JPG y PNG.');
        this.hasError.file = true; res = false;
      }
    }
    else {
      this.hasError.file = true; res = false;
    }
    return res;
  }

  validObs() {    
    let res = true;
    if (this.model.observacion == '') {      
      this.hasError.observacion = true; res = false;
    }

    if (this.model.observacion_id == 0) {      
      this.hasError.observacion_id = true; res = false;
    }

    return res;
  }

  resetErrors() {
    this.model = { id: 0, nroC31: '', fechaC31: '', montoC31: '', observacion: '', fuses: [], file: null };
    this.hasError = { nroC31: false, fechaC31: false, montoC31: false, observacion: false, file: false };
  }

  showModalAprobar(data: any) {
    this.resetErrors();
    this.file = null;
    jQuery("#file").val('');
    this.popupVisibleA = true;
    this.model.id = data.id;
    this.model.montoC31 = data.monto_fus;
    this.model.montoC31 = data.monto_fus;
    this.model.nroC31 = data.nro_c31;
  }

  showModalObs(id: number) {
    this.resetErrors();
    this.popupVisibleO = true;
    this.model.id = id;
    this.getObservacionesLista();
  }

  handleFileInput(files: FileList) {
    this.file = files.item(0);
    if (this.file != null) {
      if (this.file.size > this.maxFileSize) {
        toastr.warning('El tamaño del archivo no debe exceder los 2MB.');
      }
      if (this.typeFiles.indexOf(this.file.type) == -1) {
        toastr.warning('Formato de archivo no válido, los permitidos son PDF, JPG y PNG.');
      }
    }
  }

  convertDate(date: Date) {
    var dd = date.getDate();
    var mm = date.getMonth() + 1;
    let nd = dd.toString();
    let nm = mm.toString();
    var yyyy = date.getFullYear(); if (dd < 10) { nd = '0' + dd } if (mm < 10) { nm = '0' + mm }
    return nd + '/' + nm + '/' + yyyy;
  }

  getFusReversionesById(id: string) {
    this.resetErrors();
    this._rs.getFusReversionesById(id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.fusReversion = result.data;
          this.popupVisibleR = true;
        }
      },
      (error) => { console.log('Error', error); });
  }

  saveReversion() {
    this.jusReversion = false;
    if (this.validRev()) {
      this._rs.postFusReversion(this.fusReversion).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.getListFus(this.estado, this.tipo_agregacion_id);
            this.dataGrid.instance.refresh();
            toastr.success('Datos guardados correctamente.');
            this.clicked = false;
          }
          this.popupVisibleR = false;
        });
    }
  }

  validRev() {
    let res = true, f1 = false, f2 = false;
    if (!UtilHelper.validator(this.fusReversion.justifica_reversion, 'text')) {
      f1 = true;;
    }
    this.fusReversion.detalle.forEach(item => {
      if ((item.revertido <= 0))
        f2 = true;
    });

    if (f2) {
      res = false;
      toastr.warning('Los montos no pueden ser ceros');
    }
    if (f1) {
      res = false;
      toastr.warning('Complete la justificación');
    }
    return res;
  }

  getFusByNroFus(nroFusV: string) {
    this.nroFus = nroFusV;
    if (this.nroFus.length > 3) {
      this._fs.getFusAllByEstadoNroFUS(this.nroFus).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) { this.fuses = result.data; }
          else { this.fuses = []; }
        },
        (error) => { console.log('Error', error); });
    }
  }

  getDescribirObservacion(e: any) {
    var esNueva = this.dataResourceObs.filter(o => o.id == e.value).map(o => o.descripcion).toString();
    if (esNueva == 'Otro') {
      this.esNuevaObs = true;
      this.model.observacion = '';
    }

    else {      
      this.esNuevaObs = false;
      this.model.observacion = esNueva;
    }

  }

  getObservacionesLista() {
    this._gs.getObservaciones('FUS').subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResourceObs = result.data;
        }
        else { this.dataResourceObs = []; }
      },
      (error) => { console.log('Error', error); });
  }
  

    showModalSeg(id: string, fus: string) {
      this.fusSeg = fus;
      this._fs.getSeguimientoByFusId(id).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) { this.dataSeg = result.data; }
        },
        (error) => { console.log('Error', error); });
      this.popupVisibleSeg = true;
    }
}
